import React from "react";
import { Link } from "react-router-dom";
import "./PostCard.css";

// Interface definition
interface PostCardProps {
  id: number;
  image: string;
  title: string;
  author: string;
  date: string;
  excerpt: string;
  category?: string;
  authorImage?: string;
  showContent?: boolean;
}

const PostCard: React.FC<PostCardProps> = ({
  id,
  image,
  title,
  author,
  date,
  excerpt,
  category,
  authorImage,
  showContent = true,
}) => {
  const fallbackImage = "https://i.ibb.co/Gp7c0HB/placeholder.jpg";

  return (
    <div className="post-card">
      {/* Image */}
      <div className="post-card-image-container">
        {category && <div className="category-badge">{category}</div>}
        <Link to={`/blog/${id}`}>
          <img
            src={image}
            alt={title}
            className="post-card-image"
            onError={(e) => ((e.currentTarget as HTMLImageElement).src = fallbackImage)}
          />
        </Link>
      </div>

      {/* Post Content */}
      {showContent && (
        <div className="post-card-content">

          {/* Meta Row */}
          <div className="post-meta-row">
            {category && (
              <div className="meta-item">
                <svg className="meta-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                  <line x1="7" y1="7" x2="7.01" y2="7"></line>
                </svg>
                <span>{category}</span>
              </div>
            )}
            <div className="meta-item">
              <svg className="meta-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span>BY {author.toUpperCase()}</span>
            </div>
            <div className="meta-item">
              <svg className="meta-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <span>{date.toUpperCase()}</span>
            </div>

          </div>

          {/* Title */}
          <h3>
            <Link to={`/blog/${id}`} className="post-card-title-link">
              {title.length > 60 ? `${title.slice(0, 60)}...` : title}
            </Link>
          </h3>

          {/* Excerpt */}
          <p className="post-card-excerpt">
            {excerpt.length > 180 ? `${excerpt.slice(0, 180)}...` : excerpt}
          </p>

          {/* Read More Button */}
          <div className="post-card-footer">
            <Link to={`/blog/${id}`} className="post-card-btn">
              Continue Reading <span className="btn-square"></span>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default PostCard;
